module.exports = __webpack_public_path__ + "static/media/400387_02.9c1d2f37.png";